import { render, staticRenderFns } from "./FullNameSettings.vue?vue&type=template&id=0e257733&scoped=true"
import script from "./FullNameSettings.vue?vue&type=script&lang=js"
export * from "./FullNameSettings.vue?vue&type=script&lang=js"
import style0 from "./FullNameSettings.vue?vue&type=style&index=0&id=0e257733&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e257733",
  null
  
)

export default component.exports